// @ts-nocheck
import React, { createContext, useContext, useMemo, useState } from "react";

const RssContext = createContext();

const RssProvider = ({ children }) => {
	const [rssFilters, setRssFilters] = useState([]);

	const value = useMemo(
		() => ({ rssFilters, setRssFilters }),
		[rssFilters]
	);

	return (
		<RssContext.Provider value={value}>
			{children}
		</RssContext.Provider>
	);
};

export function useRssContext() {
	return useContext(RssContext);
}

export { RssContext, RssProvider };
